 import styled, { css } from 'styled-components';
import theme from "../../theme/theme";

interface ButtonProps {
  selected: boolean;
  pressed: boolean;
}

export const Container = styled.div<{length?: number}>`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: ${(props) => (props.length !== undefined && props.length >= 5 ? '0 30%' : '0 35%')};
  box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.25);

  @media (max-width: 1024px) {
    padding: ${(props) => (props.length !== undefined && props.length >= 5 ? '0 10%' : '0 20%')}
  }

  @media (max-width: 500px) {
    padding: 0 8%;
  }
`;

export const ButtonWrapper = styled.div<ButtonProps>`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  width: auto;
  padding: 10px;
  margin-bottom: 3px;
  opacity: ${(props) => (props.selected ? 1 : 0.5)};
  transition: transform 0.3s ease;

  ${(props) =>
    props.pressed &&
    css`
      transform: scale(0.95); // Reducimos el tamaño en un 10% (ajusta según tus preferencias)
      transition: transform 0.3s ease;
    `}

  &::after {
    content: '';
    position: absolute;
    bottom: 2px;
    left: 0;
    width: 100%;
    height: 2.5px;
    border-radius: ${(props) => (props.selected ? '15px' : '0')};
    background-color: ${(props) => (props.selected ? theme.color.navy : 'transparent')};
    transition: background-color 0.3s ease, opacity 0.3s ease; /* Agregamos transición */
  }

  &:hover {
    opacity: 1;
    transition: opacity 0.3s ease;
    &::after {
      background-color: ${(props) => (props.selected ? theme.color.navy : 'rgba(0, 0, 0, 0.2)')}; /* Cambiamos el color y la opacidad */
      opacity: 1; /* Ajustamos la opacidad al hacer hover */
    }
  }
`;

export const ButtonImage = styled.img`
  width: auto; 
  height: 40px; 
  margin: 15px 0;
  opacity: 1;
`;

export const ButtonText = styled.span`
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 400;
  opacity: 1;
  text-align: center;
`;

